import React from "react";
import Avatar from "../../../assets/images/Avatar.png";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

const Bio = ({ contentBlockId, bioText, headline, url, color, index }) => {

  const { userId, pageId } = useAppContext()

  const handlesendData = () => {
    logContentBlockPressEvent(contentBlockId);
    mixpanel.track("Web Link Clicked", {
      Button_type: "Bio",
      distinct_id: userId,
      stack_id: pageId,
    });
  };
  return (
    <div key={index} className="bioContainer" onClick={handlesendData}>
      {url ? (
        <img src={url} alt={headline} />
      ) : (
        <img src={Avatar} alt={headline} />
      )}
      {headline && <h1 style={{ color: color?.color?.primary }}>{headline}</h1>}
      {bioText && <p style={{ color: color?.color?.primary }}>{bioText}</p>}
    </div>
  );
};

export default Bio;
